// extracted by mini-css-extract-plugin
module.exports = {"noTouchAction":"shared_noTouchAction__9BsNA","touchActionPanX":"shared_touchActionPanX__U19Iz"};